import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';

/**
 * 月ナビゲーションのProps
 */
interface MonthNavigationProps {
  /** 現在表示中の月 */
  currentMonth: Date;
  /** 前月ボタンクリックハンドラー */
  onPrevious: () => void;
  /** 翌月ボタンクリックハンドラー */
  onNext: () => void;
  /** ローディング中フラグ（ボタン無効化用） */
  isLoading?: boolean;
}

/**
 * 月ナビゲーションコンポーネント
 */
export const MonthNavigation: React.FC<MonthNavigationProps> = ({
  currentMonth,
  onPrevious,
  onNext,
  isLoading = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: { xs: 1.5, md: 2 },
        py: 1.5,
        minHeight: 68,
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        sx={{
          textAlign: 'left',
          fontWeight: 700,
        }}
      >
        {format(currentMonth, 'yyyy年M月', { locale: ja })}
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.75 }}>
        <IconButton onClick={onPrevious} disabled={isLoading} aria-label="前月" size="small" sx={{ width: 32, height: 32, border: '1px solid #d8d2cd', borderRadius: '7px' }}><ChevronLeft fontSize="small" /></IconButton>
      <IconButton
        onClick={onNext}
        disabled={isLoading}
        aria-label="翌月"
        size="small"
        sx={{ width: 32, height: 32, border: '1px solid #d8d2cd', borderRadius: '7px' }}
      >
        <ChevronRight />
      </IconButton>
      </Box>
    </Box>
  );
};

export default MonthNavigation;
